import { ApiOrder, ApiOrderItem, OrderStock } from "lib/api";

export function stockItemClass(
  item: ApiOrderItem,
  warnClass: string,
  errClass: string
): string | undefined {
  if (!item.internal) {
    return undefined;
  }
  return item.internal.instock
    ? undefined
    : item.internal!.instockReappro
    ? warnClass
    : errClass;
}

export function stockOrderClass(
  order: ApiOrder,
  warnClass: string,
  errClass: string
): string | undefined {
  if (!order.internal) {
    return undefined;
  }

  switch (order.internal.stock) {
    case OrderStock.Reappro:
      return warnClass;
    case OrderStock.Missing:
      return errClass;
  }
}

export function stockTxt(item: ApiOrderItem): string {
  let stockTxt = "";
  if (item.internal) {
    if (!item.internal.instock) {
      stockTxt += item.internal.stock;
      stockTxt += `(+${item.internal.stockReappro})`;
      stockTxt += " / ";
    }
    stockTxt += item.qty.toString();
  }
  return stockTxt;
}
